<template>
  <div class="field">
    <label
      class="label"
      :for="id"
    >
      RFC
    </label>
    <div
      class="control has-icons-left"
      :class="controlClass"
    >
      <input
        :id="id"
        ref="rfc"
        :name="name"
        class="input"
        maxlength="13"
        :placeholder="placeholder"
        :pattern="rfcPattern"
        :value="value"
        :disabled="disabled"
        :required="required"
        :readonly="readonly"
        @input="onInput"
        @change="onChange"
      >
      <BIcon
        class="is-unselectable is-left"
        icon="fingerprint"
        size="is-small"
      />
      <span
        v-if="isValid && validIcon"
        class="icon is-small is-right"
      >
        <i class="material-icons is-unselectable has-text-success">
          done
        </i>
      </span>
      <p class="help is-danger">
        El valor proporcionado no es un RFC válido
      </p>
    </div>
  </div>
</template>

<script>
import merge from 'lodash/merge';
import set from 'lodash/set';

export default {
  name: 'AppInputRfc',
  props: {
    id: {
      type: String,
      default: 'rfc',
    },
    name: {
      type: String,
      default: 'rfc',
    },
    value: {
      type: String,
      default: 'XAXX010101000',
    },
    placeholder: {
      type: String,
      default: 'XAXX010101000',
    },
    disabled: {
      type: Boolean,
    },
    isLoading: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    required: {
      type: Boolean,
    },
    validIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rfcPattern: '^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$',
      isValid: false,
    };
  },
  computed: {
    controlClass() {
      return {
        'has-icons-right': this.isValid && this.validIcon,
        'is-loading': this.isLoading,
      };
    },
  },
  watch: {
    value() { this.isValid = this.$refs.rfc.checkValidity(); },
  },
  methods: {
    toUpperCase(event) {
      const { value: plainValue } = event.target;
      const value = plainValue.toUpperCase();

      const newEvent = merge({}, event);

      set(newEvent, 'target.value', value);

      return newEvent;
    },
    onInput(event) { this.$emit('input', this.toUpperCase(event)); },
    onChange(event) { this.$emit('change', this.toUpperCase(event)); },
  },
};
</script>

<style scoped>
.help.is-danger {
  position: absolute;
}
</style>
